import styled from 'styled-components';

import { Typography } from '../../shared/typography';

const Wrapper = styled.div`
	display: grid;
	align-items: center;
	height: calc(100vh - 109px);

	@media (max-width: 768px) {
		align-items: flex-start;
		overflow-y: scroll;
	}
`;

const Content = styled.div`
	padding: 0 50px;
	display: grid;
	height: 60vh;
	min-height: 400px;
	grid-template-columns: 2fr 1fr;
	grid-gap: 20px;

	@media (max-width: 1024px) {
		grid-template-columns: 1fr;
		height: 80vh;
	}

	@media (max-width: 768px) {
		background-color: ${p => p.theme.colors.white};
		height: initial;
		padding: 0;
		grid-gap: 1;
	}
`;

const Box = styled.div<{ order?: number }>`
	background-color: ${p => p.theme.colors.white};
	border-radius: 20px;
	overflow: hidden;
	justify-content: ${p => !p.order && 'space-between'};
	display: flex;
	flex-direction: column;
	border: 1px solid ${p => p.theme.colors.border};

	@media (max-width: 1024px) {
		order: ${p => (p.order === 2 ? 1 : 2)};
	}

	@media (max-width: 768px) {
		order: ${p => (p.order === 2 ? 2 : 1)};
		min-height: ${p => !p.order && '385px'};
		box-shadow: ${p =>
			`0px 2px 2px rgba(33, 33, 30, ${p.order !== 2 ? 0.1 : 0})`};
		overflow-y: visible;
		border: none;
	}
`;

const Header = styled.div`
	padding: 18px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

const Title = styled.div`
	overflow: hidden;

	@media (max-width: 768px) {
		max-width: 60%;
	}
`;

const Descr = styled.div`
	display: flex;
	align-items: center;

	@media (max-width: 768px) {
		& > span {
			display: none;
		}
	}
`;

const Logo = styled.img`
	height: 23px;
	margin-right: 20px;
	object-fit: cover;

	@media (max-width: 768px) {
		margin-right: 0;
	}
`;

const ModalContent = styled.div`
	display: flex;
	height: 100%;
	align-items: center;
	flex-direction: column;
`;

const CloseBtnWrapper = styled.div`
	position: absolute;
	top: 20px;
	right: 20px;

	@media (max-width: 768px) {
		top: 0px;
		right: 0px;
	}
`;

const btnSize = 43;
const RoundBtn = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${p => p.theme.colors.border};
	width: ${btnSize}px;
	height: ${btnSize}px;
	border-radius: ${btnSize / 2}px;
	border-width: 0;

	&:hover {
		cursor: pointer;
	}

	@media (max-width: 768px) {
		background-color: ${p => p.theme.colors.white};
	}
`;

const ModalTitle = styled(Typography)`
	font-size: 40px;
	line-height: 50px;
	margin-bottom: 66px;

	@media (max-width: 768px) {
		margin-top: 50px;
		font-size: 32px;
		line-height: 42px;
	}
`;

const BtnContainer = styled.div`
	width: 100%;
`;

const Separator = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 50px 0;
`;

const Line = styled.div`
	flex: 3;
	height: 1px;
	background-color: ${p => p.theme.colors.btnTextGrey};
`;

const SeparatorText = styled(Typography)`
	flex: 1;
	text-align: center;
`;

const exportedObject = {
	Wrapper,
	Content,
	Box,
	Header,
	Title,
	Descr,
	Logo,
	ModalContent,
	CloseBtnWrapper,
	RoundBtn,
	ModalTitle,
	BtnContainer,
	Separator,
	Line,
	SeparatorText,
};

export default exportedObject;
